;(function(doc, $){
    $(doc).ready(function () {
        $('.pro-list').on('click', '.add-car', function(e){
            var h2 = $('.mml-ttacncart')[0];
            var vCart = h2.__vue__;
            vCart.add(e, this);
        });
        var total = 0;
        let proHtml;
        let ids = [];
        let id;
        let cid = 0;
        let pageId = 1;
        let fragment = document.createDocumentFragment();
        var $data;
        var clickable = true;
        let options = {
            "prev" : '<i class="fas fa-angle-left"></i>',
            "next": '<i class="fas fa-angle-right"></i>',
            "activeClass": "active",
            "href": "javascript:;",
            "click": function (page) {
                if (!clickable) return false;
                clickable = false;
                cid = ids.toString() ? ids.toString() : 0;                
                $('.pro-list').empty().html("<li>loading products...</li>");
                getData(cid, page);
            }
        };
        function getData(cid,pageId=1) {
            let myajax = $.ajax({
                type: "GET",
                url: "/wp-common/products.php?cid="+cid+"&pid=" + pageId,
                dataType: "json",
                success: function (res) {
                    $data = res.data;
                    total = res.page_count;
                    if (total <= 1) {
                        $(".pn-btn").css('visibility','hidden');                       
                    } else {
                        $(".pn-btn").show();
                    }
                    $(".pn-btn").mmlpage(pageId, total, options);
                    proHtml = "";
                    $.each($data,function (index, item) {
                        proHtml =`
                            <li>
                                <div class="img-div" data-imgList="${item.img_list}">
                                    <img src="${item.image}" alt="s04-product-img"/>
                                    <div class="mask"><i class="iconfont iconfangda"></i> </div>
                                </div>
                                <h6>${item.name}</h6>
                                <a href="javascript:;" class="add-car btn-hover" data-id="${item.id}" data-image="${item.image}" data-name="${item.name}">
                                    <i class="iconfont iconjiarugouwuche"></i><span>Enquiry</span>
                                </a>
                            </li>
                        `;         
                        fragment.appendChild($(proHtml)[0]);
                    });
                    $('.pro-list').empty();
                    if (total == 0) {
                        $(".pro-list").addClass('noData').html("<li>Sorry,There are no products.Please re-select.</li>");
                    } else {
                        $(".pro-list").removeClass('noData');
                    }
                    $('.pro-list').append(fragment);
                    clickable = true;
                }
            });
            myajax.fail(function (jqXHR, textStatus) {
                alert("Request failed: " + textStatus);
            });
        }
        getData(0,1);
        
        $('.sub-filter').on('click','li',function () {
            $(this).addClass("checking");
            id = $(this).attr('data-id');
            if(ids.indexOf(id) == -1) {
                ids.push(id);
            }
            cid = ids.toString();
            getData(cid,1);
        });
        $('.sub-filter li .guanbi').click(function (e) {
            e.stopPropagation();
            $(this).parent().removeClass("checking");
            id = $(this).parent().attr('data-id');
            ids.splice(ids.indexOf(id), 1);               
            cid = ids.toString();
            getData(cid,1);
        });
        
        var $products = $('.products');
        var productsTop = $products.parent().offset().top;            
        $(document).scroll(function () {
            var scrollTop = $(document).scrollTop();
            if (scrollTop >= productsTop && scrollTop <= (productsTop + $products.height() + 10 +$('.top_bar_left').height())) {
                $('.filters').addClass('fixed');
            } else {
                $('.filters').removeClass('fixed');
            }
        });

        $('.filter-tgl').on('click', function(){
            $(this).parent().toggleClass('collapsed');
        });
        $('.filter-confirm').click(function () {
            $(".filters").addClass("collapsed");
        });
        var data = [];
        var $gallery = $('#lightgallery-pro');
        $(document).on('click', '.pro-list .img-div', function () {
            let id = $(this).parent('li').find('a').attr('data-id');                
            let imgList = $(this).attr('data-imgList').split(",");                
            let len = imgList.length;
            for(let i =0; i < len; i++ ) {
                data[i] = {
                    src: imgList[i],
                    thumb: imgList[i]
                }
            }
            data.length = len;
            $gallery.lightGallery({
                closable: false,
                animateThumb: true,
                showThumbByDefault: true,
                dynamic: true,
                dynamicEl: data
            });
            $(document).on('click','.lg-img-wrap',function () {
                $('#lightgallery-pro').data('lightGallery').destroy();
            });
            $(document).on('click','.lg-img-wrap img',function (e) {
                e.stopPropagation(); 
            });
        });

        
    });
})(document, jQuery);